<template>
    <li
        class="house-slider-item"
        :class="{ mobile: isMobile, 'house-sold': soldDate }"
        :title="address"
        @click="openDetail(link, $event)"
    >
        <article>
            <a
                :href="linkData.href"
                :target="linkData.target"
                :aria-label="linkData['aria-label']"
                :self="linkData.self"
            >
                <div class="house-imgs">
                    <site-img
                        v-if="firstImage"
                        :src="firstImage"
                        :errorImg="defHouseImg"
                        dir="width"
                    />
                    <div v-else class="default-img">
                        <site-img
                            :src="picSrc"
                            dir="width"
                        /> 
                    </div>
                    <p v-if="soldDate && isMobile" :class="['house-sold-date', statusOrigin]">
                        <only-client>
                            <span v-if="showStar">{{ $t('md-house.soldOnWith', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                            <span v-else>{{ $t('md-house.soldOn', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                        </only-client>
                    </p>
                    <house-mask
                        v-if="isShowMask"
                        display="fill-up"
                    />
                    <div class="img-mask" v-if="!isShowMask && firstImage"></div>  
                </div>

                <div class="house-info">
                    <div class="addressAndprice"> 
                        <div class="address-wrap" v-if="!isMobile"> 
                            <div class="address" v-if="address">
                                <a
                                    :href="linkData.href"
                                    :target="linkData.target"
                                    :aria-label="linkData['aria-label']"
                                    :self="linkData.self"
                                >{{ address }}</a> 
                            </div>
                            <p class="detail">
                                <span
                                    :class="['vertical-line', `house-${item.key}`]"
                                    v-for="item in basic"
                                    :key="item.key"
                                >{{ item.text }}</span>
                            </p>
                        </div>
                        <div class="house-price-wrap">
                            <p v-if="soldDate && !isMobile" :class="['house-sold-date', statusOrigin]">
                                <only-client>
                                    <span v-if="showStar">{{ $t('md-house.soldOnWith', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                                    <span v-else>{{ $t('md-house.soldOn', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                                </only-client>
                            </p>
                            <title-mask-v2 v-if="isShowMask" />
                            <no-disclosure
                                v-else-if="!!house.nodisclosureDes || hidePrice"
                                :des="
                                    hidePrice
                                        ? $t('md-house.nondisclosure')
                                        : house.nodisclosureDes
                                "
                            />
                            <template v-else-if="soldDate">
                                <span class="house-sold-price">
                                    {{ markPrice.replace(/\s/g, '') }}
                                </span>
                                <div class="sold-price-trend">
                                    <span
                                        class="house-initial-price"
                                        v-if="showAllPrice && initialPrice"
                                    >
                                        {{ $ft.trim(initialPrice) }}
                                    </span>
                                    <HouseTrend
                                        v-if="showAllPrice && trend"
                                        :trendStatus="trendStatus"
                                        :trend="trend"
                                    />
                                </div>
                            </template>
                            <div v-else class="house-price">
                                {{ price.replace(/\s/g, '') }}
                            </div>
                        </div>
                    </div>
                    <p class="detail" v-if="isMobile">
                        <span
                            :class="['vertical-line', `house-${item.key}`]"
                            v-for="item in basic"
                            :key="item.key"
                        >{{ item.text }}</span>
                    </p>
                    <h3 class="address" v-if="address && isMobile">
                        <a
                            :href="linkData.href"
                            :target="linkData.target"
                            :aria-label="linkData['aria-label']"
                            :self="linkData.self"
                        >{{ address }}</a>
                    </h3>
                    <div class="mls-box">
                        <div class="mls-provided">
                            <p v-if="showMls" class="house-mls-id">
                                MLS# {{ mlsid }}
                            </p>
                            <p
                                v-if="provided && !isShowMask"
                                class="desc ws-pre-wrap"
                            >
                                {{ provided }}
                            </p>
                        </div>
                        <site-img
                            v-if="mlsLogo"
                            class="house-mls-logo"
                            :src="mlsLogo"
                            :alt="mlsAlt"
                            :size="30"
                            :lazy="false"
                            dir="height"
                        />
                    </div>
                </div>
            </a>  
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>
<script>
import Item from '../item.js';
import HouseItem from '../house-item.js';
import OnlyClient from '@/components/global/only-client.vue';
export default {
    components: { OnlyClient },
    mixins: [HouseItem, Item],
    data: function() {
        return {
            picSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/md-house/layout6.png',
            // isShowMask: false
        };
    }
};
</script>
<style lang="scss">
.md-house.layout8 {
    .house-slider-item {
        pointer-events: auto;
        > article {
            display: inherit;
            flex-direction: inherit;
            width: 100%;
            height: 100%;
            position: relative;
            cursor: pointer;
            pointer-events: auto;
        }

        .house-sold-date {
            span {
                display: inline-block;
                white-space: nowrap;
                font-family: var(--font-normal);
                font-size: 12px;
                line-height: 20px;
                font-weight: 700;
                height: 20px;
                padding: 0 5px;
                border-radius: 0;
                color: #fff;
                background-color: #505050;
            }
        }

        .house-imgs {
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;
            pointer-events: auto;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
                will-change: transform;
            }

            .default-img {
                width: 100%;
                height: 100%;
                background: rgba(218, 218, 218, 1);
                opacity: 0.2;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width: 64px;
                    height: 56px;
                }
            }

            .house-sold-date {
                position: absolute;
                top: 15px;
                right: 15px;
            }
        }

        &:hover {
            .house-imgs img {
                transform: scale(1.1);
                .default-img {
                    img {
                        transform: scale(1);
                    }
                }
            }
        }

        .img-mask {
            background: rgba(25, 25, 25, 0.5);
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }

        .house-info {
            width: 100%;
            height: 100%;
            padding: 20px;
            box-sizing: border-box;
            background: transparent;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 20;
            display: none;
            flex-direction: column;
            justify-content: space-between;

            .addressAndprice {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 50px;
            }
            .house-price-wrap {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 10px;

                .house-sold-price {
                    font-family: var(--mg-title-font);
                    font-size: 24px;
                    line-height: 36px;
                    color: #fff;
                }

                .sold-price-trend {
                    display: flex;
                    .house-initial-price {
                        font-family: var(--font-normal);
                        font-size: 16px;
                        line-height: 20px;
                        text-decoration: line-through;
                        color: #fff;
                        opacity: 0.7;
                    }
                    .house-trend {
                        font-weight: 700;
                    }
                }
                
                .house-price,
                .hide-price {
                    font-family: var(--mg-title-font);
                    font-size: 24px;
                    line-height: 36px;
                    color: #fff;
                    cursor: pointer;
                }
            }

            .detail {
                font-family: var(--font-normal);
                font-size: 14px;
                line-height: 21px;
                color: #fff;

                .vertical-line:after {
                    content: '|';
                    display: inline;
                    margin: 0 8px;
                    color: #fff;
                }
                .vertical-line:nth-last-child(1):after {
                    content: '';
                }
            }

            .address {
                font-family: var(--mg-title-font);
                font-size: 24px;
                line-height: 36px;
                color: #fff;
                margin-bottom: 10px;
            }

            .mls-box {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                gap: 20px;

                .house-mls-logo {
                    flex-shrink: 0;
                    max-height: 24px;
                    max-width: 120px;
                    object-fit: contain;
                    vertical-align: middle;
                }
                .house-mls-id,
                .desc {
                    color: rgba(255, 255, 255, 0.8);
                    font-family: var(--font-normal);
                    font-size: 12px;
                    line-height: 18px;
                    text-align: left;
                }
            }
        }

        &.mobile {
            > article {
                height: auto;
            }
            .house-imgs {
                width: 100%;
                height: 225px;
            }
            .house-info {
                margin-top: 10px;
                display: block;
                width: 100%;
                height: auto;
                padding: 0;
                position: static;

                .addressAndprice {
                    display: block;
                }

                .house-price-wrap {
                    align-items: flex-start;
                    gap: 5px;

                    .house-sold-price {
                        font-size: 20px;
                        line-height: 30px;
                        color: var(--g-primary-color);
                    }

                    .sold-price-trend {
                        .house-initial-price {
                            opacity: 0.7;
                            color: var(--g-primary-color);
                        }
                    }

                    .house-price,
                    .hide-price {
                        font-size: 26px;
                        line-height: 30px;
                        cursor: pointer;
                        color: var(--g-primary-color);
                    }
                }

                .detail {
                    margin-top: 15px;
                    color: var(--g-primary-color);
                    margin-bottom: 5px;
                    .vertical-line:after {
                        color: var(--g-primary-color);
                    }
                }
                .address {
                    font-family: var(--font-normal);
                    color: var(--g-primary-color);
                    font-size: 14px;
                    line-height: 20px;
                    margin-bottom: 0;
                }

                .mls-box {
                    margin-top: 20px;
                    .house-mls-id,
                    .desc {
                        color: var(--g-text-color);
                        font-style: italic;
                    }
                }
            }
        }
    }
}
</style>
